import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Challenge, ContentSettingV2 } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_ALL_PATIENT_CHALLENGES_BY_ID_KEY = 'get-all-patient-challenges-by-id';

export const useGetAllPatientChallengesByID = (patientId: number) => {
  return usePermittedQuery<ContentSettingV2<Challenge>[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () =>
      `/challenge/get-all-patient-challenge-settings/${patientId}?withAlerts=true&zoneId=America/Chicago`,
    {
      headers: {
        Accept: 'application/vnd.ysh.api.v2+json',
      },
    },
    [GET_ALL_PATIENT_CHALLENGES_BY_ID_KEY, patientId],
    {
      enabled: typeof patientId === 'number' && patientId > 0,
      refetchOnWindowFocus: false,
    },
  );
};
